import { useCallback, useMemo } from 'react';

import { getDefaultLanguage } from './get-default-language';
import { useAppSelector } from '@/store/hooks';
import { selectProjectPreview } from '@/store/slices/project/selectors';
import { getChannels } from '@/store/slices/channels/selectors';
import { getUser } from '@/store/slices/user/selectors';
import getPrefixUrl from './get-prefix-url';
import { stageEnvironment } from './urls';
import { BrandliveEvent } from '@/types/projects.types';

const useGetPreviewUrl = (project: BrandliveEvent | null) => {
  const eventPreviewBySelector = useAppSelector(selectProjectPreview);
  const channels = useAppSelector(getChannels);
  const user = useAppSelector(getUser);

  const eventPreview = project?.event_preview || eventPreviewBySelector;

  const channel = useMemo(() => {
    if (!channels || !user) return;
    return channels.find((channel) => channel.channel === user.active_channel);
  }, [channels, user]);

  const determinPreviewUrl = useCallback(() => {
    if (!project || !channel || !eventPreview) return '';

    const defaultLanguage = getDefaultLanguage(project);
    if (stageEnvironment.isLocal) {
      return `http://localhost:3000/event/${eventPreview.url}/${defaultLanguage}`;
    } else {
      return `${getPrefixUrl(channel.url)}/${eventPreview.url}/${defaultLanguage}`;
    }
  }, [project, channel, eventPreview]);

  return determinPreviewUrl();
};

export default useGetPreviewUrl;
